

  const divButton = document.getElementsByClassName("benefit-split__content")[0];
  //recoger primer href del boton
  const linkButtom = divButton.querySelector("a");
  const elementoDestino = document.getElementsByTagName("lumin-product-qty-break")[1];

  // 2. Le asignamos la función al botón cuando se haga "click"
  linkButtom.addEventListener("click", function(event) {
    event.preventDefault();
    elementoDestino.scrollIntoView({ 
      behavior: "smooth", 
      block: "center" 
    });
  });

  const divButton2 = document.getElementsByClassName("homepage-v2-testimonials")[0];
    //recoger primer href del boton
  const linkButton2 = divButton2.querySelector("a");
  linkButton2.addEventListener("click", function(event) {
    event.preventDefault();
    elementoDestino.scrollIntoView({
      behavior: "smooth", 
      block: "center" 
    });
  });

  const section_benefits = document.getElementsByClassName("arnes-benefits-content")[0];
  const arrayLinks = section_benefits.getElementsByTagName("a");

  for (let i = 0; i < arrayLinks.length; i++) {
    arrayLinks[i].addEventListener("click", function(event) {
      event.preventDefault();
      elementoDestino.scrollIntoView({
        behavior: "smooth", 
        block: "center" 
      });
    });
    }